import type { IDeviceListItem } from '@/feature/device/types/device';

import type { IDeviceActionHandler } from './deviceActionTypes';

interface IDeviceViewButtonProps {
  device: IDeviceListItem;
  onAction: IDeviceActionHandler;
}

const DeviceViewButton = ({ device, onAction }: IDeviceViewButtonProps) => (
  <button
    type='button'
    className='inline-flex items-center justify-center p-1.5 rounded-md text-theme-600 hover:text-theme-700 hover:bg-theme-50/90 bg-transparent border-0 cursor-pointer transition-colors'
    aria-label='View details'
    onClick={() => onAction('view', device)}
  >
    <svg
      className='shrink-0 w-4 h-4'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden={true}
    >
      <path
        d='M1 8C1 8 3.5 3 8 3C12.5 3 15 8 15 8C15 8 12.5 13 8 13C3.5 13 1 8 1 8Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='8' cy='8' r='2' stroke='currentColor' strokeWidth='1.5' />
    </svg>
  </button>
);

export default DeviceViewButton;
